import Heading3 from 'components/Heading3';
import Text from 'components/Text';

import styles from './styles.module.scss';

const ModalHeaderTitle = ({
    headerHeadingClassName,
    headerTextClassName,
    text,
    title
}) => (
    <div className={styles.modalHeaderTitle}>
        <Heading3
            className={`${headerHeadingClassName} ${styles.heading3}`}
            text={title}
        />

        <Text className={`${headerTextClassName} ${styles.text}`} text={text} />
    </div>
);

export default ModalHeaderTitle;
